import React from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import { DownloadOutlined   } from '@ant-design/icons';

import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
  style?:any
};

const ExtractButton = ({ style,comcode, ...otherProps }: ButtonProps) => {
  const { isHidden, label } = useComponentConfiguration(comcode);

  if (isHidden) {
    return null;
  }

  const props = {
    ...otherProps,
    children: label,
    style,
  };

  if (props.to) {
    return <RouterLink component={AntButton} {...props} />;
  } else {
    return <AntButton {...props} type="ghost" icon={<DownloadOutlined style={{fontSize:'large'}}/>} style={style??{width:'100%',height:50}} />;
  }
};

export default ExtractButton;
